/*
2021-07-05 SVEN Kommentarbereich für Versionierung, Kommentare
2021-07-13 SVEN required im Inputfield verhindert leere Eingabe
*/

import React from 'react';
import './InputField.css'

// Inputfield für Eingabe MAC-Adresse
// akzeptiert nur bestimmtes Format siehe pattern
const InputField = (props) => {
    return (
        <form onSubmit={props.submit}>
            <input  
                required
                id="macadresse"
                name="MAC-Adresse"
                placeholder= "Bitte MAC-Adresse eingeben.."
                type="text"
                value={props.value}
                onChange={props.changed}
                pattern="^([0-9a-fA-F]{2}[:-]?){5}[0-9a-fA-F]{2}$"
                title= "Format: 12 Stellen Hexadezimal, Leerzeichen, - und : werden automatisch entfernt (Bsp: 12AB34BC56DE)"
            />
            <br></br>
            <button type="submit">Information anfordern</button>
        </form>
    )
};
export default InputField;